import React, { useState, useEffect, useMemo } from "react";

import Pagination from "../../Config/Pagination";
import { API_BASE_CRM_URL } from "../../Config/Config";
import { useNavigate } from "react-router-dom";
import "../../Config/search.css";
import "../../Config/loader.css";
import "../../Config/loading.css";

import Base from "../../Config/Base";
import { Footer } from "../footer/footer";
import { Select, Spin } from "antd";
import Swal from "sweetalert2";
import axios from "axios";

export default function Todo() {
  const navigate = useNavigate();

  const [todoData, setTodoData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [staffOptions, setStaffOptions] = useState([]);
  const [selectedStaffId, setSelectedStaffId] = useState(0);
  const [staffLoading, setStaffLoading] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [updatingTodoId, setUpdatingTodoId] = useState(null);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [description, setDescription] = useState("");
  const [userDetails, setUserDetails] = useState();
  // const [loading, setLoading] = useState(false);

  const [showUpdateTodo, setShowUpdateTodo] = useState(false);
  const [updateTodoData, setUpdateTodoData] = useState({
    todoid: "",
    description: "",
    item_order: "",
  });

  useEffect(() => {
    const userDetails = JSON.parse(sessionStorage.getItem("userDetails"));
    setUserDetails(userDetails);
    if (!userDetails) {
      navigate("/");
    }
  }, [navigate]);

  const fetchData = async () => {
    setLoading(true);

    try {
      const response = await fetch(
        `${API_BASE_CRM_URL}todo/GetTodos?staffid=${selectedStaffId}&finished=${selectedStatus}`,
      );

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await response.json();

      if (data.Status) {
        setTodoData(data.ResultData || []);
      } else {
        setTodoData([]);
      }
    } catch (error) {
      console.error("Error fetching todos:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [selectedStaffId, selectedStatus]);

  const getStaffDropdown = async () => {
    try {
      setStaffLoading(true);

      const response = await fetch(`${API_BASE_CRM_URL}staff/GetStaffDropdown`);

      const data = await response.json();

      if (data?.Status) {
        const options = [
          {
            label: "All",
            value: 0,
          },
          ...(data.ResultData || []).map((staff) => ({
            label: `${staff.firstname} ${staff.lastname}`.trim(),
            value: staff.staffid,
          })),
        ];

        setStaffOptions(options);
      }
    } catch (error) {
      console.error("Error fetching staff list:", error);
    } finally {
      setStaffLoading(false);
    }
  };

  useEffect(() => {
    getStaffDropdown();
  }, []);

  const itemsPerPage = 12;

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  const filteredItems = useMemo(() => {
    return todoData.filter(
      (item) =>
        item.staff_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.description?.toLowerCase().includes(searchTerm.toLowerCase()),
    );
  }, [todoData, searchTerm]);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredItems.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const statusOptions = [
    {
      label: "All",
      value: "",
    },
    {
      label: "Completed",
      value: 1,
    },
    {
      label: "Pending",
      value: 0,
    },
  ];

  const handleTodoStatusChange = async (todo) => {
    setUpdatingTodoId(todo.todoid);

    try {
      const response = await fetch(`${API_BASE_CRM_URL}todo/UpdateTodoStatus`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          todoid: todo.todoid,
          finished: todo.finished === 1 ? 0 : 1,
        }),
      });

      const data = await response.json();

      if (data.Status) {
        await fetchData();
      } else {
        console.error(data.Message || "Failed to update todo");
      }
    } catch (error) {
      console.error("Error updating todo:", error);
    } finally {
      setUpdatingTodoId(null);
    }
  };

  const formatDateTime = (date) => {
    if (!date) return "N/A";

    return new Date(date).toLocaleString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  const handleSubmitTodo = async (e) => {
    e.preventDefault();

    if (!description.trim()) {
      Swal.fire({
        icon: "warning",
        title: "Description Required",
        text: "Please enter a description",
      });
      return;
    }

    setLoading(true);

    const payload = {
      description: description,
      staffid: userDetails.staffid,
      item_order: 1,
    };

    try {
      const response = await fetch(`${API_BASE_CRM_URL}todo/AddTodo`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const result = await response.json();

      if (result.Status) {
        Swal.fire({
          icon: "success",
          title: result.Message,
          text: `Todo ID: ${result.TodoId}`,
        });

        setDescription("");
        setIsModalOpen(false);
        fetchData();
      } else {
        Swal.fire({
          icon: "error",
          title: result.Message || "Failed to add todo",
        });
      }
    } catch (error) {
      console.error(error);

      Swal.fire({
        icon: "error",
        title: "Something went wrong",
        text: error.message,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateChange = (e) => {
    const { name, value } = e.target;

    setUpdateTodoData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleUpdateTodo = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);

      const payload = {
        todoid: updateTodoData.todoid,
        description: updateTodoData.description,
        staffid: userDetails.staffid,
        item_order: Number(updateTodoData.item_order),
      };

      const response = await axios.post(
        `${API_BASE_CRM_URL}todo/UpdateTodo`,
        payload,
      );

      if (response.data.Status) {
        await Swal.fire({
          icon: "success",
          title: "Success",
          text: response.data.Message,
          confirmButtonColor: "#1B2850",
          timer: 2000,
          showConfirmButton: false,
        });

        setShowUpdateTodo(false);
        fetchData();
      }
    } catch (error) {
      console.error(error);

      Swal.fire({
        icon: "error",
        title: "Update Failed",
        text: error?.response?.data?.Message || "Failed to update todo",
        confirmButtonColor: "#dc3545",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteTodo = async (todoid) => {
    const result = await Swal.fire({
      title: "Delete Todo?",
      text: "This action cannot be undone.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#dc3545",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Yes, Delete",
      cancelButtonText: "Cancel",
    });

    if (!result.isConfirmed) return;

    try {
      setLoading(true);

      const response = await axios.post(`${API_BASE_CRM_URL}todo/DeleteTodo`, {
        todoid,
      });

      if (response.data.Status) {
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "success",
          title: response.data.Message,
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true,
        });

        fetchData();
      }
    } catch (error) {
      console.error(error);

      Swal.fire({
        icon: "error",
        title: "Delete Failed",
        text: error?.response?.data?.Message || "Unable to delete todo",
        confirmButtonColor: "#dc3545",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Base>
      <div className="">
        <div className="d-flex justify-content-between">
          <div className="page-title">
            <h4>Todo</h4>
            <h6>Manage your Leads</h6>
          </div>
          <div>
            <ul className="d-inline-flex list-unstyled gap-1 mb-0 justify-content-end">
              <li>
                <button
                  className="btn btn btn-sm"
                  style={{ backgroundColor: "#1B2850" }}
                  onClick={() => setIsModalOpen(true)}
                >
                  <i
                    className="fa-solid fa-plus"
                    style={{ color: "white" }}
                  ></i>
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="row g-3 align-items-center my-2">
        <div className="col-6 m-0">
          <Select
            showSearch
            allowClear
            placeholder="Select Staff"
            loading={staffLoading}
            value={selectedStaffId}
            options={staffOptions}
            style={{ width: "100%" }}
            optionFilterProp="label"
            filterOption={(input, option) =>
              (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
            }
            onChange={(value) => setSelectedStaffId(value ?? 0)}
            notFoundContent={loading ? <Spin size="small" /> : "No Staff Found"}
          />
        </div>

        <div className="col-6 m-0">
          <Select
            placeholder="Select Status"
            value={selectedStatus}
            options={statusOptions}
            style={{ width: "100%" }}
            onChange={(value) => setSelectedStatus(value)}
          />
        </div>

        <div className="col-4 m-0"></div>
      </div>
      <div className="col-12 mb-3">
        <div className="input-group">
          <input
            type="text"
            name="search"
            placeholder="Search..."
            className="form-control"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <span className="input-group-text bg-primary" id="basic-addon1">
            <i className="fa-solid fa-magnifying-glass"></i>
          </span>
        </div>
      </div>

      <div className="card-container mb-5">
        {loading ? (
          <div className="containers m-auto">
            <div className="dot"></div>
            <div className="dot"></div>
            <div className="dot"></div>
            <div className="dot"></div>
            <div className="dot"></div>
            <div className="dot"></div>
          </div>
        ) : (
          <div className="row g-2 mb-2">
            {currentItems.map((item) => (
              <div key={item.todoid} className="col-12 col-md-6 col-lg-4">
                <div
                  className={`card mb-2 rounded-4 border-0 shadow-sm ${
                    item.finished ? "bg-light" : ""
                  }`}
                >
                  {/* <div className="card-body">
                    
                    <div className="d-flex align-items-start">
                      <div className="me-3 mt-1">
                        {updatingTodoId === item.todoid ? (
                          <div
                            className="spinner-border spinner-border-sm"
                            role="status"
                          />
                        ) : (
                          <input
                            type="checkbox"
                            className="form-check-input"
                            checked={item.finished === 1}
                            onChange={() => handleTodoStatusChange(item)}
                            style={{
                              width: "20px",
                              height: "20px",
                              cursor: "pointer",
                            }}
                          />
                        )}
                      </div>

                      <div className="flex-grow-1">
                        <h6
                          className={`mb-2 ${
                            item.finished
                              ? "text-decoration-line-through text-muted"
                              : ""
                          }`}
                        >
                          {item.description}
                        </h6>
                         
                       

                      
                        <div className="d-flex gap-5">
                          <small className="text-muted">
                            <i
                              className="fa-solid fa-user me-2"
                              style={{ color: "#1B2850" }}
                            ></i>
                            {item.staff_name}
                          </small>

                          <small className="text-muted">
                            <i
                              className="fa-solid fa-calendar-days me-2"
                              style={{ color: "#1B2850" }}
                            ></i>
                            {formatDateTime(item.dateadded)}
                          </small>
                        </div>
                        {item.finished === 1 && item.datefinished && (
                          <small className="text-success">
                            <i className="fa-solid fa-circle-check me-2"></i>
                            Completed on {formatDateTime(item.datefinished)}
                          </small>
                        )}
                      </div>
                    </div>
                  </div> */}

                  <div className="card-body">
                    <div className="d-flex justify-content-between align-items-start">
                      <div className="d-flex">
                        <div className="me-3 mt-1">
                          {updatingTodoId === item.todoid ? (
                            <div
                              className="spinner-border spinner-border-sm"
                              role="status"
                            />
                          ) : (
                            <input
                              type="checkbox"
                              className="form-check-input"
                              checked={item.finished === 1}
                              onChange={() => handleTodoStatusChange(item)}
                              style={{
                                width: "20px",
                                height: "20px",
                                cursor: "pointer",
                              }}
                            />
                          )}
                        </div>

                        <div>
                          <h6
                            className={`mb-2 ${
                              item.finished
                                ? "text-decoration-line-through text-muted"
                                : ""
                            }`}
                          >
                            {item.description}
                          </h6>
                        </div>
                      </div>

                      {/* Edit Icon */}
                      <div className="d-flex align-items-center gap-3">
                        {/* Edit */}
                        <i
                          className="fa-solid fa-pen-to-square"
                          style={{
                            color: "#1B2850",
                            fontSize: "15px",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            setUpdateTodoData({
                              todoid: item.todoid,
                              description: item.description,
                              item_order: item.item_order,
                            });

                            setShowUpdateTodo(true);
                          }}
                        />

                        {/* Delete */}
                        <i
                          className="fa-solid fa-trash"
                          style={{
                            color: "#dc3545",
                            fontSize: "15px",
                            cursor: "pointer",
                          }}
                          onClick={() => handleDeleteTodo(item.todoid)}
                        />
                      </div>
                    </div>

                    {/* Footer Details */}
                    <div className="mt-2">
                      <div className="d-flex gap-5">
                        <small className="text-muted">
                          <i
                            className="fa-solid fa-user me-2"
                            style={{ color: "#1B2850" }}
                          ></i>
                          {item.staff_name}
                        </small>

                        <small className="text-muted">
                          <i
                            className="fa-solid fa-calendar-days me-2"
                            style={{ color: "#1B2850" }}
                          ></i>
                          {formatDateTime(item.dateadded)}
                        </small>
                      </div>

                      {item.finished === 1 && item.datefinished && (
                        <small className="text-success">
                          <i className="fa-solid fa-circle-check me-2"></i>
                          Completed on {formatDateTime(item.datefinished)}
                        </small>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}

        <div className="">
          <Pagination
            itemsPerPage={itemsPerPage}
            totalItems={filteredItems.length}
            paginate={paginate}
            currentPage={currentPage}
          />
        </div>
      </div>
      {isModalOpen && (
        <>
          <div
            className="offcanvas offcanvas-bottom show"
            style={{
              visibility: "visible",
              height: "40vh",
              zIndex: 1055,
              borderTopLeftRadius: "20px",
              borderTopRightRadius: "20px",
              backgroundColor: "#fff",
            }}
          >
            {/* Drag Handle */}
            <div className="text-center pt-2">
              <div
                style={{
                  width: "50px",
                  height: "5px",
                  background: "#ccc",
                  borderRadius: "10px",
                  margin: "0 auto",
                }}
              />
            </div>

            {/* Header */}
            <div className="offcanvas-header border-bottom d-flex justify-content-between align-items-center">
              <h5
                className="mb-0"
                style={{
                  color: "#1B2850",
                  fontWeight: "600",
                }}
              >
                <i className="fa-solid fa-list-check me-2"></i>
                Add Todo
              </h5>

              <div className="d-flex gap-2">
                {/* Cancel */}
                <div
                  onClick={() => {
                    setIsModalOpen(false);
                    setDescription("");
                  }}
                  style={{
                    width: "38px",
                    height: "38px",
                    background: "#fff",
                    borderRadius: "8px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
                  }}
                >
                  <i
                    className="fa-solid fa-xmark"
                    style={{
                      color: "#dc3545",
                      fontSize: "16px",
                    }}
                  />
                </div>

                {/* Save */}
                <div
                  onClick={handleSubmitTodo}
                  style={{
                    width: "38px",
                    height: "38px",
                    background: "#fff",
                    borderRadius: "8px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
                  }}
                >
                  <i
                    className={`fa-solid ${
                      loading ? "fa-spinner fa-spin" : "fa-check"
                    }`}
                    style={{
                      color: "#198754",
                      fontSize: "16px",
                    }}
                  />
                </div>
              </div>
            </div>

            {/* Body */}
            <div className="offcanvas-body">
              <label className="form-label fw-semibold">Description</label>

              <textarea
                rows={5}
                className="form-control"
                placeholder="Enter Description"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </div>
          </div>

          {/* Backdrop */}
          <div
            className="offcanvas-backdrop fade show"
            onClick={() => {
              setIsModalOpen(false);
              setDescription("");
            }}
          />
        </>
      )}

      {showUpdateTodo && (
        <>
          <div
            className="offcanvas offcanvas-bottom show"
            style={{
              visibility: "visible",
              height: "40vh",
              zIndex: 1055,
              borderTopLeftRadius: "20px",
              borderTopRightRadius: "20px",
            }}
          >
            <div className="offcanvas-header border-bottom d-flex justify-content-between align-items-center">
              {/* Left Side */}
              <h5
                className="offcanvas-title mb-0"
                style={{
                  color: "#1B2850",
                  fontWeight: "600",
                }}
              >
                Update Todo
              </h5>

              {/* Right Side */}
              <div className="d-flex align-items-center gap-2">
                {/* Cancel */}
                <div
                  onClick={() => setShowUpdateTodo(false)}
                  style={{
                    width: "38px",
                    height: "38px",
                    background: "#fff",
                    borderRadius: "8px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
                  }}
                >
                  <i
                    className="fa-solid fa-xmark"
                    style={{ color: "#dc3545", fontSize: "16px" }}
                  />
                </div>

                {/* Save */}
                <div
                  onClick={handleUpdateTodo}
                  style={{
                    width: "38px",
                    height: "38px",
                    background: "#fff",
                    borderRadius: "8px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
                  }}
                >
                  <i
                    className={`fa-solid ${
                      loading ? "fa-spinner fa-spin" : "fa-check"
                    }`}
                    style={{ color: "#198754", fontSize: "16px" }}
                  />
                </div>
              </div>
            </div>

            <div className="offcanvas-body">
              <form onSubmit={handleUpdateTodo}>
                <div className="mb-3">
                  <label className="form-label">Description</label>

                  <textarea
                    className="form-control"
                    rows="4"
                    name="description"
                    value={updateTodoData.description}
                    onChange={handleUpdateChange}
                    placeholder="Enter Description"
                    required
                  />
                </div>
              </form>
            </div>
          </div>

          <div
            className="offcanvas-backdrop fade show"
            onClick={() => setShowUpdateTodo(false)}
          ></div>
        </>
      )}

      <Footer></Footer>
    </Base>
  );
}
